import { ITransportDetailSection } from 'types/transport'
import DetailInfoArea from 'components/transport/DetailInfoArea';
import Loading from 'components/common/Loading';

const BookingSchedule = ({ detailInfo, type, loading }: ITransportDetailSection) => {

    if (loading) return <div className='flex justify-center items-center h-96'><Loading /></div>

    return (
        <div className='flex flex-col justify-start items-start gap-6 px-10 py-6 text-lg'>
            {
                type === 'SEA' &&
                <>
                    <DetailInfoArea
                        title='운송선사'
                        value={detailInfo?.detailInfo?.carrierName ?? ''}
                    />
                    <DetailInfoArea
                        title={'선박명'}
                        value={detailInfo?.detailInfo?.vesselName ?? ''}
                    />
                    <DetailInfoArea
                        title={'항차'}
                        value={detailInfo?.detailInfo?.voyage ?? ''}
                    />
                </>
            }

            <DetailInfoArea
                title={type === 'SEA' ? '입항일(ETA)' : 'ETA'}
                value={detailInfo?.detailInfo?.eta ?? ''}
            />
            <DetailInfoArea
                title={type === 'SEA' ? '출항일(ETD)' : 'ETD'}
                value={detailInfo?.detailInfo?.etd ?? ''}
            />

            {
                type === 'AIR' &&
                <>
                    {
                        detailInfo.transitInfo &&
                        detailInfo.transitInfo.length > 0 &&
                        detailInfo.transitInfo.map((item, idx) => (
                            <DetailInfoArea
                                key={idx}
                                isTag
                                title={`경유지 <span class='flex justify-center items-center bg-primary rounded-full w-4.5 h-4.5 text-white text-xs'>${idx + 1}</span>`}
                                value={`${item.transitCode} | ${item.transitAddress}`} />
                        ))
                    }
                </>
            }
        </div>
    )
}

export default BookingSchedule